import BrandList from './BrandList';
import BrandCreate from './BrandCreate';
import BrandEdit from './BrandEdit';

export default {
    list: 	BrandList,
    create: BrandCreate,
    edit: 	BrandEdit
};
